import { Row, Col, Descriptions } from 'antd';

const LABEL_STYLE = {
  width: 150,
  color: '#454C53'
};

const CONTENT_STYLE = {
  maxWidth: 260,
  color: '#1A1D21'
};

function Overview({ cols }) {
  const itemsView = cols?.map((col) => {
    const items = col?.items?.map((item) => (
      <Descriptions.Item labelStyle={LABEL_STYLE} contentStyle={CONTENT_STYLE} label={item?.label}>
        {item?.value}
      </Descriptions.Item>
    ));
    return (
      <Col span={12}>
        <Descriptions colon={false} column={1}>
          {items}
        </Descriptions>
      </Col>
    );
  });

  return <Row>{itemsView}</Row>;
}

export default Overview;
